var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNonveg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 988322"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1400",
    x: 0.5,
    y: 0.5,
    width: 15,
    height: 15,
    rx: 1.5,
    stroke: "#ED3946"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 21",
    d: "M7.97436 3L3 12H13L7.97436 3Z",
    fill: "#ED3946"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNonveg);
export default __webpack_public_path__ + "static/media/nonveg.bbfbcc1a3bbe9aef7e84bea4736b34d0.svg";
export { ForwardRef as ReactComponent };